require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-announces-leadership-promotions-and-new-hire.json") })
        }
      }, "path---es-articles-financial-center-announces-leadership-promotions-and-new-hire");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-announces-leadership-promotions-and-new-hire!./.cache/json/es-articles-financial-center-announces-leadership-promotions-and-new-hire.json
// module id = 2100
// module chunks = 231608221292675